import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { Aggregation } from 'store/productivityRate.store';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

import { RangeWithCustom } from 'components/common/GlobalFiltersInPage/components/dateRangeFilter/dateRangeFilter';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryProductivityRate = (params: QueryParams, endpoint?: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['productivityRate', params],
        queryFn: () => queryFn(params, endpoint),
        enabled:
            Boolean(params.actualMetaDataId) &&
            Boolean(params.comparedMetaDataId) &&
            Boolean(params.range) &&
            Boolean(params.range === 'R_CUSTOM' ? params.startDate && params.endDate : true) &&
            Boolean(params.aggregation),
        cacheTime: 0,
    });
};

interface QueryParams extends NarrativeRequest {
    actualMetaDataId: number | undefined;
    comparedMetaDataId: number | undefined;
    range: RangeWithCustom | undefined;
    startDate: number | null;
    endDate: number | null;
    aggregation: Aggregation | undefined;
    filter: {
        filters: IFilter[];
    };
}

export interface QueryResponse {
    chart:
        | {
              endDate: number;
              futureActual: number;
              futurePlanned: number;
              previousActual: number;
              previousPlanned: number;
              startDate: number;
          }[]
        | null;
    futurePlanned: {
        activities: number;
        date: number;
        rangeLabel: string;
    } | null;
    pastActual: {
        activities: number;
        date: number;
        rangeLabel: string;
    } | null;
    pastPlanned: {
        activities: number;
        date: number;
        rangeLabel: string;
    } | null;
    startChartDate: number | null;
    endChartDate: number | null;
    calculatedVersionDate: number | null;
    info: IToolTip;
}
